import { render, staticRenderFns } from "./shuiyin.vue?vue&type=template&id=06b47ad8&scoped=true"
import script from "./shuiyin.vue?vue&type=script&lang=js"
export * from "./shuiyin.vue?vue&type=script&lang=js"
import style0 from "./shuiyin.vue?vue&type=style&index=0&id=06b47ad8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b47ad8",
  null
  
)

export default component.exports